import { Themable } from '@billy/design-system/src/types/themable'
import styled from '@emotion/styled'

export const InvoiceEditorContentProcessingOverlayBackground = styled.div<Themable>`
  opacity: 0.6;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
  background-color: ${({ theme }) => theme.ds.colors.base.background};
`
